var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mx-0"},_vm._l((_vm.dictionary),function(word){return _c('v-col',{key:word.german,staticClass:"py-1 px-0",attrs:{"cols":"12"}},[_c('DictionaryCard',{attrs:{"displayCategory":_vm.displayCategory,"word":word}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }